import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

// Auth uses an httpOnly cookie set by the backend; the browser sends it automatically.
axios.defaults.withCredentials = true;

export const AuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(null); // null = checking, true, false
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/auth/me`)
      .then((r) => { setAdmin(r.data); setAuthed(true); })
      .catch(() => { setAdmin(null); setAuthed(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setAdmin({ email: data.email, role: data.role });
    setAuthed(true);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (e) {
      console.error("Uitloggen mislukt:", e);
    }
    setAdmin(null);
    setAuthed(false);
  }, []);

  // Kept for call-site compatibility; auth now travels via the httpOnly cookie.
  const authHeader = useCallback(() => ({}), []);

  const value = useMemo(
    () => ({ authed, admin, login, logout, authHeader }),
    [authed, admin, login, logout, authHeader]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
export { API };
